import Calendar from 'vue-event-calendar-ext'
import 'vue-event-calendar-ext/dist/index.css'

export default Calendar



// WEBPACK FOOTER //
// ./src/components/calendar/index.js